/*
 * 通用指令
 */
import Vue from 'vue'

var localPermissionObj = null
function checkPermission(permissionCode) {
  var userPermissions = localPermissionObj || (top.GetUserAllRoles && top.GetUserAllRoles())
  if (userPermissions && !localPermissionObj) {
    localPermissionObj = userPermissions
  }
  return userPermissions && userPermissions[permissionCode]
}

// 权限指令
Vue.directive('power', {
  inserted: function (el, binding) {
    // 检查权限码
    var hasPermission = checkPermission(binding.value)
    // 如果没有权限，从DOM中移除元素
    if (!hasPermission) {
      el && (el.style.display = 'none')
    }
  }
})
